import * as React from "react";
import { Highlighter } from "~/sharedComponents/highlighter";
import { icon, Icon, IconNames } from "~/sharedComponents/icons";
import { Indent } from "~/sharedComponents/indent";
import { Box, Flex } from "~/sharedComponents/layout";
import { entityThumbnails } from "~/sharedComponents/thumbnails/consts";
import { EntityThumbnail } from "~/sharedComponents/thumbnails/EntityThumbnail";
import { Qtip } from "~/sharedComponents/tooltip";
import { getRowStyle } from "../listRows";
import { VirtListRowProps } from "./BaseList";
import * as listStyles from "./VirtList.less";

export const ListRowDefault = <TItem extends {}>(props: VirtListRowProps<TItem>) => {
    const { textForHighlight, item, getItemLabel, selected, getItemType, isItemDisabled, disabledItemTooltip } = props;
    const itemType = getItemType?.(item);

    const row = (
        <Flex gap={8} className={getRowStyle(props)}>
            {itemType && <EntityThumbnail item={entityThumbnails[itemType]} />}
            <Highlighter
                showTitle={true}
                className={listStyles.label}
                text={getItemLabel(item)}
                textForHighlight={textForHighlight}
            />
            <RowCheckMark selected={selected} />
        </Flex>
    );

    const showTooltip = isItemDisabled?.(item) && disabledItemTooltip;

    if (showTooltip) {
        return (
            <Qtip>
                <div>{row}</div>
                <Box>{disabledItemTooltip}</Box>
            </Qtip>
        );
    }

    return row;
};

export const ListRowDefaultWithIcon = <TItem extends {}>(props: VirtListRowProps<TItem & { icon?: IconNames }>) => {
    const { item, getItemLabel, textForHighlight } = props;

    return (
        <div className={getRowStyle(props)}>
            {item.icon && (
                <>
                    <Icon iconName={item.icon} />
                    <Indent />
                </>
            )}
            <Highlighter text={getItemLabel(item)} textForHighlight={textForHighlight} />
        </div>
    );
};

type CheckMarkProps = Pick<VirtListRowProps<any>, "selected"> & Pick<React.ComponentProps<typeof Icon>, "color">;

export const RowCheckMark: React.FC<CheckMarkProps> = ({ selected, color }) =>
    !!selected && <Icon iconName={icon.check} className={listStyles.row_icon} color={color} />;
